import { Injectable, Type, ComponentFactoryResolver } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { BaseService } from './base.service';
import { AlertsService } from '../../services/alerts.service';
import { AppService } from './app.service';
import { DomSanitizer } from '@angular/platform-browser';

declare var window: any;
@Injectable({
    providedIn: 'root'
})
export class PrintService {
    constructor(private baseService: BaseService, private loader: LoaderService, private alerts: AlertsService, private appService?: AppService, private sanitizer?: DomSanitizer,) { }

    handleFileReponse(fileObj, action, fileData, callback = null) {
        var fileName = "";
        var fileResponse: any = "";
        let initialContentType = "application/";
        let default_content_type = fileObj.contentType;
        //  no_of_print_copy = 1;
        if (fileObj && fileObj.args && fileObj.args.includes('no_of_print_copy')) {
            const parts = fileObj.args.split(',');
            const noOfPrintCopyPart = parts.find(part => part.startsWith('no_of_print_copy:'));
            // Extract the value after 'no_of_print_copy:'
            if (noOfPrintCopyPart) {
                var no_of_print_copy = parseInt(noOfPrintCopyPart.split(':')[1], 10);
            }
        }

        if (fileObj.contentTypeChange != undefined && fileObj.contentTypeChange) {
            // splited the fileobj contentType for #143820 issue
            default_content_type = fileObj.contentType.split("/")[1];
        }
        
        if (fileObj.contentType != 'byte_array') {
            fileName = fileObj.KeyWithExt != undefined ? fileObj.KeyWithExt : fileObj.key + '.' + default_content_type;
            fileObj.contentType = initialContentType + fileObj.contentType;//TODO (we have to get from mapping)
            fileResponse = fileData;
            if(fileObj != undefined && fileObj && fileObj.contentType != undefined && fileObj.s3 != undefined && fileObj.s3 && initialContentType != ''){
                fileObj.contentType = fileObj.contentType.replace(initialContentType,'');   // for replacing concatenated contentType 
            }
        } else {

            fileName = (fileData.documentName != undefined) ? fileData.documentName : fileObj.key;
            fileObj.contentType = (fileData.documentContentType != undefined) ? fileData.documentContentType : fileObj.contentType;
            if (fileData.inputStream != undefined && fileData.inputStream.length > 0) {
                var fileData = fileData.inputStream;
                fileResponse = new Uint8Array(fileData.length);
                for (let i = 0; i < fileResponse.length; i++) {
                    fileResponse[i] = fileData[i];
                }
            } else {
                this.alerts.error('File Data not found');
                this.loader.hideSpinner();
                if (callback) {
                    callback(false);
                }
                return;
            }
        }
        var insidenative = this.appService.checkNativeApp();
        switch (action) {
            case "download":
                this.baseService.downloadFile(fileResponse, fileObj.contentType, fileName, callback);
                break;
            case "print":
                this.baseService.printFile(fileResponse, fileObj.contentType, fileName, callback, no_of_print_copy);
                // this.baseService.printFile(fileResponse, fileObj.contentType, fileName, callback);
                break;
            case "print-async":
                this.baseService.printFile(fileResponse, fileObj.contentType, fileName, callback);
                break;
            case "view_file":
                this.baseService.viewFile(fileResponse, fileObj.contentType, fileName, callback);
                break;

            default:
                break;
        }
    }
    handlePrint(action, obj, callback?) {
        if (action.file_data != undefined) {
            var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
            this.loader.showSpinner();
            var fileObj = JSON.parse(JSON.stringify(action.file_data));
            fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
            fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
            fileObj.resource = this.baseService.buildDyanamicStr(fileObj.resource, obj);
            fileObj.application = 'report-management';
            fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
            fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, { data: obj }) : false;
            fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, { data: obj }) : false;
            if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && obj) {
                fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : obj.facility_id);
            } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && obj == undefined) {
                fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
            }
            fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
            this.baseService.handleFile(fileObj, async (fileData) => {
                if (fileData) {
                    if (fileData.type == "application/json") {
                        try {
                            var response = await fileData.text();
                            response = JSON.parse(response);
                            if (response.errCode == -1 && response.message != undefined) {
                                this.alerts.error(response.message);
                            }
                            console.log(response);
                        } catch (e) {
                            this.alerts.error('API error');
                        }
                    } else {
                        fileObj.key = key;
                        this.handleFileReponse(fileObj, action.action, fileData, callback);
                    }
                } else {
                    this.alerts.error('server error');
                    if (callback) {
                        callback(false);
                    }

                }
                this.loader.hideSpinner();
            });
        } else {
            console.error("Please provide File Data");
            if (callback) {
                callback(false);
            }
        }

    }

    uploadDownloadedData(pdfBlob, fileName, resource, baseResource, userId, contentType, callback){
        pdfBlob = pdfBlob.slice(0, pdfBlob.size, contentType);
         var reader = new FileReader();
         reader.onload = ((file) => {
            return (evt) => {
            };
        })(pdfBlob);
        reader.onloadend = () => {       
            var file = new File([pdfBlob], fileName,{type: contentType});
            const formData = new FormData();
            formData.append('file', file);
            formData.append('fileName', fileName);
            formData.append('action', 'add');
            formData.append('userId', userId);
            if(baseResource != null){
                formData.append('resource', window.btoa(unescape(encodeURIComponent(JSON.stringify(baseResource)))));
            }
            
            this.loader.showSpinner();
            this.baseService.upload(formData, "dms", resource,reader.result).subscribe(
            (data: any) => {
                if(data.errCode == 0)
                    callback(data);
                else
                    callback(false);
                this.loader.hideSpinner();
            }, error => {
                console.log(error);
                callback(false);
                this.alerts.error(error);
                this.loader.hideSpinner();
            });
          };
          reader.readAsDataURL(pdfBlob);
    }

}



